<template>
  <div class="unifled-login-wrapper">
    <div style="width: 25%;position: relative">
      <div class="tip-box">
        <img src="../../assets/images/SzTech/左边图.png" class="tipImg" />
        <div class="tip-msg">
          <div class="tiao"></div>
          <div class="tip-tite">用户名称：</div>
          <div>{{ userName }}</div>
        </div>
        <!--        <div class="tip-msg">-->
        <!--          <div class="tiao"></div>-->
        <!--          <div class="tip-tite">用户部门：</div>-->
        <!--          <div>材料部</div>-->
        <!--        </div>-->
        <div class="tip-msg">
          <div class="tiao"></div>
          <div class="tip-tite">联系号码：</div>
          <div>{{ phonenumber }}</div>
        </div>
      </div>
    </div>
    <div style="width: 65%;">
      <div class="title-box">
        <div class="title">欢迎进入深圳市新材料知识产权智慧枢纽服务平台</div>
      </div>
      <div class="unifed-box">
        <div style="flex: 1">
          <img src="../../assets/images/SzTech/专利导航.png" />
          <div class="unifed-title">专利导航</div>
          <div class="unifed-msg">数据挖掘、产业分析</div>
          <a-button type="primary" class="btn" size="large" @click="click(0)"
            >点击进入</a-button
          >
        </div>
        <div style="flex: 1">
          <img
            src="../../assets/images/SzTech/公共服务.png"
            style="margin-top: 30%"
          />
          <div class="unifed-title">公共服务</div>
          <div class="unifed-msg">供需匹配、开放许可</div>
          <a-button type="primary" class="btn" size="large" @click="click(1)"
            >点击进入</a-button
          >
        </div>
        <div style="flex: 1">
          <img src="../../assets/images/SzTech/保护工作站.png" />
          <div class="unifed-title">保护工作站</div>
          <div class="unifed-msg">风险防控、维权援助</div>
          <a-button type="primary" class="btn" size="large" @click="click(2)"
            >点击进入</a-button
          >
        </div>
      </div>
    </div>
    <a-dropdown>
      <a class="ant-dropdown-link" @click.prevent>
        {{ userName + ',您好' }}
        <a-icon type="down" />
      </a>
      <template #overlay>
        <a-menu>
          <a-menu-item>
            <a href="javascript:;" @click="back">退出登录</a>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
import { getStorage } from '@/utils'
import { getAccountInfos, getUserInfo } from '@/api/accountInfos.js'
import { productDataBase } from '@/api/competitor'
export default {
  data() {
    return {
      userName: '',
      phonenumber: ''
    }
  },
  created() {
    this.getToken()
  },
  methods: {
    click(i) {
      this.getToken()
      switch (i) {
        case 0:
          productDataBase().then(res => {
            const { access_token } = res.data
            const { refresh_token } = res.data
            window.open(
              `http://5q16p85626.zicp.vip:10000/token?token=${access_token}&refresh_token=${refresh_token}`
            )
          })
          break
        case 1:
          window.open(
            this.$router.resolve({ path: '/platformPortal' }).href,
            '_blank'
          )
          break
        case 2:
          getUserInfo().then(res => {
            window.open(
              'http://materials.szmma.org.cn/share/userinfo?code=' + res.code
            )
          })
          break
      }
    },
    back() {
      this.$router.push('/login')
    },
    getToken() {
      let token = getStorage('token', 0)
      if (!token || token === '') {
        return this.$router.push('/login')
      }
      getAccountInfos().then(res => {
        if (res.code === 200) {
          this.userName = res.data.userName
          this.phonenumber = res.data.phonenumber
        }
      })
    }
  }
}
</script>

<style scoped>
.unifled-login-wrapper {
  background: url('../../assets/images/SzTech/页面2背景.png') center center /
    100% no-repeat;
  background-size: cover;
  height: -webkit-calc(100vh);
  min-width: 17.06667rem;
  overflow: hidden;
  position: relative;
  display: flex;
}

.title-box {
  width: 100%;
  height: 25%;
  font-weight: bold;
  font-size: 32px;
  color: #fff;
  position: relative;
}

.title {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  letter-spacing: 2px;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
}

.unifed-box {
  display: flex;
  text-align: center;
}

.unifed-box img {
  width: 282px;
  height: 253px;
  margin-top: 20%;
  object-fit: contain;
}

.tipImg {
  margin-top: 20px;
  width: 70px;
  text-align: center;
}

.unifed-title {
  letter-spacing: 2px;
  font-weight: bold;
  font-size: 32px;
  color: #fff;
  margin-top: 20px;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
}

.unifed-msg {
  font-weight: bold;
  font-size: 25px;
  color: #fff;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
  margin-bottom: 20px;
}

.btn {
  background-color: #0d61e8;
}

.tip-box {
  width: 230px;
  height: 300px;
  background-color: #fff;
  position: absolute;
  right: 40px;
  top: 0;
  bottom: 0;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
  margin: auto;
  text-align: center;
}

.tip-msg {
  width: 80%;
  height: 13%;
  margin-left: 40px;
  margin-top: 30px;
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}

.tip-tite {
  color: #2a5fe9;
}

.tiao {
  float: left;
  width: 4px;
  background: #2a5fe9;
  height: 96%;
  margin-top: 6px;
  margin-right: 10px;
}

.ant-dropdown-link {
  color: #fff;
  position: absolute;
  right: 200px;
  top: 20px;
}
</style>
